// import Vue from 'vue'
import { Quasar } from 'quasar'
import { getLanguage } from 'src/boot/i18n'

export default async () => {
  let langIso = getLanguage()

  // hook for EN only
  if (langIso === 'en') {
    langIso = 'en-us'
  }

  try {
    await import(
      /* webpackInclude: /(nl|en-us)\.js$/ */
      'quasar/lang/' + langIso
    ).then(lang => {
      Quasar.lang.set(lang.default)
    })
  } catch (err) {
    // Requested Quasar Language Pack does not exist,
    // let's not break the app, so catching error
  }
}
